<template>
  <div class="app-container">
    <headerTop></headerTop>
    <div class="body-box">
      <router-view />
    </div>
    <login></login>
  </div>
</template>

<script>
import headerTop from "@/components/headerTop/headerTop";
import login from "@/components/login/login.vue";

export default {
  components: {
    headerTop,
    login,
  },
  data() {
    return {};
  },
  created() {
    this.$store.dispatch("loadPublicDic");
    this.$store.dispatch("loadUserList");
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.body-box {
  background-color: #f9f9f9;
  min-height: 100vh;
  max-width: 100vw;
}
</style>
